import { sendHttpRequest } from "lib/fetcher";
import { IPSpeakerSearchDataType } from "lib/types";
import useWsSender from "lib/wsSenderHook";
import axios from "axios";

export type WsCameraSettingReq = {
  id: number;
  name: string;
  mainStream?: {
    bitRate: number;
    frameRate: number;
    resolution: {
      height: number;
      width: number;
      name: string;
    };
  };
  subStream?: {
    bitRate: number;
    frameRate: number;
    resolution: {
      height: number;
      width: number;
      name: string;
    };
  };
};
export function useCustomersService() {
  const { sendWsRequest } = useWsSender();
  // async function sendUpdateCameraNameRequest(
  //   cameras: { id: number; name: string }[],
  //   orgId,
  // ) {
  //   return sendWsRequest(
  //     "device.update_cameras_name",
  //     {
  //       deviceUpdateCamerasName: {
  //         data: cameras,
  //       },
  //     },
  //     { orgId },
  //   );
  // }

  async function sendUpdateCameraSettingRequest(
    cameras: WsCameraSettingReq[],
    orgId,
  ) {
    return sendWsRequest(
      "device.update_cameras_settings",
      {
        deviceUpdateCamerasSettings: {
          data: cameras,
        },
      },
      { orgId, timeout: 35000 },
    );
  }

  async function sendSearchDeviceRequest(data, orgId) {
    return sendWsRequest(
      "device.search",
      {
        deviceSearch: data,
      },
      { orgId, timeout: 25000 },
    );
  }

  async function sendAddDeviceRequest(
    siteId: number,
    nvrId: number,
    data: IPSpeakerSearchDataType[],
    orgId,
  ) {
    return sendWsRequest(
      "device.speaker.add",
      {
        deviceSpeakerAdd: {
          siteId,
          nvrId,
          data,
        },
      },
      { orgId, timeout: 25000 },
    );
  }

  async function sendValidateDeviceRequest(data, orgId) {
    return sendWsRequest(
      "device.validate",
      {
        deviceValidate: {
          validateAccounts: [data],
        },
      },
      { orgId },
    );
  }

  return {
    sendUpdateCameraSettingRequest,
    sendSearchDeviceRequest,
    sendAddDeviceRequest,
    sendValidateDeviceRequest,
  };
}
export function getCamerasBySite(siteId, orgId) {
  return sendHttpRequest({
    url: "/camera/cameras?page.limit=300&siteId=" + siteId,
    method: "get",
    headers: {
      "x-org-id": orgId,
    },
  });
}
export function savePanoramaSettings(id, data, orgId) {
  return sendHttpRequest({
    url: `/site/sites/${id}/panorama_settings`,
    method: "patch",
    data: {
      data,
    },
    headers: {
      "x-org-id": orgId,
    },
  });
}

export function getTimezoneFromGoogleMapApi(lat, lng) {
  const apiKey = "AIzaSyAqk45RIVytV7tiTjTy2UISpHEgSWjl1vg";
  const timestamp = Math.floor(new Date().getTime() / 1000);
  const instance = axios.create({
    baseURL: "https://maps.googleapis.com", // google map api url
    timeout: 5000,
  });
  return instance.get(
    `/maps/api/timezone/json?location=${lat}%2C${lng}&timestamp=${timestamp}&key=${apiKey}`,
  );
}
